module.exports = __webpack_public_path__ + "static/img/04.b1230dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/04.jpg
// module id = /gp8
// module chunks = 0